/* Swee Choon — required "Type of occasion" + "How did you hear about us" for catering (added 1 Oct 2026).
 * Config comes from layout/theme.liquid (window.SC_EVENTINFO).
 * 1. Catering product pages: two required dropdowns above Add to Cart. Add to Cart is blocked until both
 *    are chosen. Answers are saved as cart attributes ("Occasion", "How did you hear about us") BEFORE the
 *    item is added, so they appear on the Shopify order under Additional details.
 * 2. Cart page / cart drawer: if the cart holds catering items and either answer is missing, Check Out is
 *    blocked and the customer answers on the cart page.
 * The configurator page collects the same two answers itself and passes them in its cart link.
 * Never changes prices or cart lines. */
(function () {
  'use strict';
  var CFG = window.SC_EVENTINFO || {};
  var K_OCC = 'Occasion', K_SRC = 'How did you hear about us';
  var LS = 'sc_event_info_v1';
  var OCCASIONS = ['Corporate Event / Meeting', 'Seminar / Conference / Training', 'Office Party / Team Celebration',
    'Birthday', 'Baby Full Month', 'Wedding / Solemnisation', 'Housewarming', 'Festive Celebration (CNY, Christmas, etc.)',
    'Family Gathering', 'Religious / Prayer Function', 'School Function', 'Charity / Community Event', 'Others'];
  var SOURCES = ['Google Search', 'Google Maps', 'Instagram', 'Facebook', 'TikTok', 'Xiaohongshu (RED)',
    'Influencer / Food Blogger', 'Friends / Family / Colleague', 'Dined at a Swee Choon restaurant',
    'Ordered Swee Choon catering before', 'Brochure / Flyer', 'News / Media article', 'ChatGPT / AI assistant', 'Others'];
  window.SC_EVENTINFO_OPTIONS = { occasions: OCCASIONS, sources: SOURCES };

  var cartState = CFG.cart || { catering: false, occasion: '', heard: '' };
  var realFetch = window.fetch.bind(window);

  /* ---------- helpers ---------- */
  function readLS() { try { return JSON.parse(localStorage.getItem(LS) || '{}') || {}; } catch (e) { return {}; } }
  function writeLS(o) { try { localStorage.setItem(LS, JSON.stringify(o)); } catch (e) {} }
  // Stored value is "Others: <text>" or a list option; split back into select + text
  function splitVal(v, list) {
    v = v || '';
    if (list.indexOf(v) !== -1) return { sel: v, other: '' };
    if (v.indexOf('Others') === 0) return { sel: 'Others', other: v.replace(/^Others:?\s*/, '') };
    return { sel: '', other: '' };
  }
  function joinVal(sel, other) {
    if (!sel) return '';
    if (sel === 'Others' && other && other.trim()) return 'Others: ' + other.trim().slice(0, 120);
    return sel;
  }
  function track(name, params) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params || {})); } catch (e) {}
  }

  var saving = null, savedKey = '';
  function saveAttributes(occ, src) {
    var key = occ + '||' + src;
    if (key === savedKey && !saving) return Promise.resolve();
    var attrs = {}; attrs[K_OCC] = occ; attrs[K_SRC] = src;
    var p = realFetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('attributes ' + r.status);
      savedKey = key; cartState.occasion = occ; cartState.heard = src;
    }).catch(function (e) { try { console.warn('[event-info] save failed', e); } catch (_) {} })
      .finally(function () { if (saving === p) saving = null; });
    saving = p;
    return p;
  }

  /* ---------- panel UI (shared by product + cart page) ---------- */
  function css() {
    if (document.getElementById('sc-evinfo-css')) return;
    var s = document.createElement('style'); s.id = 'sc-evinfo-css';
    s.textContent =
      '#sc-event-info{border:1.5px solid #ae0a2b;background:#fff;border-radius:8px;padding:14px 16px;margin:14px 0 12px;font-family:inherit;text-align:left}' +
      '#sc-event-info .sc-ev-title{color:#ae0a2b;font-weight:700;letter-spacing:.06em;font-size:13px;margin:0 0 4px;text-transform:uppercase}' +
      '#sc-event-info .sc-ev-sub{font-size:13px;color:#555;margin:0 0 10px;line-height:1.4}' +
      '#sc-event-info .sc-ev-field{margin:0 0 10px}' +
      '#sc-event-info label.sc-ev-label{display:block;font-size:14px;font-weight:600;margin:0 0 4px;color:#222;text-transform:none;letter-spacing:normal}' +
      '#sc-event-info label.sc-ev-label b{color:#ae0a2b}' +
      '#sc-event-info select,#sc-event-info input[type=text]{width:100%;max-width:100%;min-height:44px;padding:8px 10px;border:1px solid #cfc6bd;border-radius:6px;background:#fff;font-size:15px;color:#222;box-sizing:border-box}' +
      '#sc-event-info input[type=text]{margin-top:6px}' +
      '#sc-event-info .sc-ev-bad select{border:2px solid #ae0a2b;background:#fff5f5}' +
      '#sc-event-info .sc-ev-msg{display:none;color:#ae0a2b;font-size:13px;font-weight:600;margin-top:4px}' +
      '#sc-event-info.sc-ev-error{background:#fff8f8}' +
      '#sc-event-info.sc-ev-error .sc-ev-msg{display:block}';
    document.head.appendChild(s);
  }
  function selectEl(id, list, val) {
    var s = document.createElement('select'); s.id = id; s.required = true;
    var o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'Please select'; s.appendChild(o0);
    list.forEach(function (t) { var o = document.createElement('option'); o.value = t; o.textContent = t; if (t === val) o.selected = true; s.appendChild(o); });
    return s;
  }
  function buildPanel(initial, onChange) {
    css();
    var occ = splitVal(initial.occasion, OCCASIONS), src = splitVal(initial.heard, SOURCES);
    var box = document.createElement('div'); box.id = 'sc-event-info';
    box.innerHTML = '<div class="sc-ev-title">About your event</div>' +
      '<div class="sc-ev-sub">Required before adding to cart and checking out.</div>';
    function field(id, labelText, list, v) {
      var wrap = document.createElement('div'); wrap.className = 'sc-ev-field';
      var lab = document.createElement('label'); lab.className = 'sc-ev-label'; lab.htmlFor = id;
      lab.innerHTML = labelText + ' <b>*</b>';
      var sel = selectEl(id, list, v.sel);
      var other = document.createElement('input'); other.type = 'text'; other.id = id + '-other';
      other.placeholder = 'Please specify (optional)'; other.maxLength = 120; other.value = v.other;
      other.style.display = v.sel === 'Others' ? '' : 'none';
      wrap.appendChild(lab); wrap.appendChild(sel); wrap.appendChild(other);
      sel.addEventListener('change', function () {
        other.style.display = sel.value === 'Others' ? '' : 'none';
        if (sel.value) wrap.classList.remove('sc-ev-bad');
        changed();
      });
      other.addEventListener('change', changed);
      return { wrap: wrap, sel: sel, other: other };
    }
    var f1 = field('sc-ev-occasion', 'Type of occasion', OCCASIONS, occ);
    var f2 = field('sc-ev-source', 'How did you hear about us?', SOURCES, src);
    var msg = document.createElement('div'); msg.className = 'sc-ev-msg';
    msg.textContent = 'Please select the type of occasion and how you heard about us to continue.';
    box.appendChild(f1.wrap); box.appendChild(f2.wrap); box.appendChild(msg);
    function values() { return { occasion: joinVal(f1.sel.value, f1.other.value), heard: joinVal(f2.sel.value, f2.other.value) }; }
    function changed() {
      var v = values();
      if (v.occasion && v.heard) box.classList.remove('sc-ev-error');
      writeLS(v);
      onChange(v);
    }
    box.__values = values;
    box.__showError = function () {
      if (!f1.sel.value) f1.wrap.classList.add('sc-ev-bad');
      if (!f2.sel.value) f2.wrap.classList.add('sc-ev-bad');
      box.classList.add('sc-ev-error');
      try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { box.scrollIntoView(); }
      (f1.sel.value ? f2.sel : f1.sel).focus({ preventScroll: true });
    };
    return box;
  }
  function initialValues() {
    var ls = readLS();
    return {
      occasion: cartState.occasion || ls.occasion || '',
      heard: cartState.heard || ls.heard || ''
    };
  }

  /* ---------- 1. catering product pages ---------- */
  function isAddUrl(u) { return /\/cart\/add(\.js)?(\?|$)/i.test(u || ''); }
  if (CFG.productIsCatering) {
    var panel = null;
    var addSel = '.avis-new-addcart-button, form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] input[name="add"]';
    function visibleAddBtn() {
      var list = document.querySelectorAll(addSel);
      for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null) return list[i];
      return list[0] || null;
    }
    function mount() {
      if (panel && document.body.contains(panel)) return;
      var btn = visibleAddBtn();
      if (!btn || !btn.parentNode) return;
      panel = buildPanel(initialValues(), function (v) {
        if (v.occasion && v.heard) saveAttributes(v.occasion, v.heard);
        track('catering_event_info_change', { occasion: v.occasion || null, heard_from: v.heard || null });
      });
      var est = document.getElementById('sc-price-estimate');
      var anchor = (est && est.parentNode === btn.parentNode) ? est : btn;
      anchor.parentNode.insertBefore(panel, anchor);
      var v0 = panel.__values();
      if (v0.occasion && v0.heard) saveAttributes(v0.occasion, v0.heard);
    }
    function valid() { if (!panel) return false; var v = panel.__values(); return !!(v.occasion && v.heard); }
    function block(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      mount(); if (panel) panel.__showError();
      track('catering_event_info_missing', { page: 'product', handle: CFG.handle || null });
    }
    // Click / submit gate (window capture runs before the options app and theme handlers)
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest(addSel) : null;
      if (!t) return;
      if (!valid()) block(e);
    }, true);
    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute || !isAddUrl(f.getAttribute('action'))) return;
      if (!valid()) block(e);
    }, true);
    // Network backstop: hold any add-to-cart until answers exist and are saved to the cart
    function ready() {
      if (!valid()) return Promise.resolve(false);
      var v = panel.__values();
      return saveAttributes(v.occasion, v.heard).then(function () { return saving || null; }).then(function () { return true; });
    }
    var prevFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var self = this, args = arguments;
      if (!isAddUrl(url)) return prevFetch.apply(self, args);
      return ready().then(function (ok) {
        if (!ok) { if (panel) panel.__showError(); return Promise.reject(new Error('Event details required')); }
        return prevFetch.apply(self, args);
      });
    };
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__sceUrl = u; return xOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this, args = arguments;
      if (!isAddUrl(xhr.__sceUrl)) return xSend.apply(xhr, args);
      ready().then(function (ok) { if (ok) xSend.apply(xhr, args); else { try { xhr.abort(); } catch (e) {} if (panel) panel.__showError(); } });
    };
    var tries = 0;
    (function poll() { mount(); if (++tries < 40) setTimeout(poll, 500); })();
    new MutationObserver(function () { if (!panel || !document.body.contains(panel)) mount(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 2. checkout gate (cart page + drawer, every page) ---------- */
  function refreshCart() {
    return realFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      var hs = CFG.handles || [];
      var cat = (c.items || []).some(function (i) {
        return (i.sku || '').indexOf('CAT-') === 0 || i.vendor === 'Swee Choon Catering v2' || hs.indexOf(i.handle) !== -1;
      });
      var a = c.attributes || {};
      cartState.catering = cat; cartState.occasion = a[K_OCC] || ''; cartState.heard = a[K_SRC] || '';
      syncCartPanel();
      return cartState;
    }).catch(function () { return cartState; });
  }
  function missing() { return cartState.catering && !(cartState.occasion && cartState.heard); }
  var onCartPage = /^\/cart\/?$/.test(location.pathname);
  var cartPanel = null;
  function syncCartPanel() {
    if (!onCartPage) return;
    var wrap = document.querySelector('.cart__checkout-wrapper');
    if (!cartState.catering) { if (cartPanel) { cartPanel.remove(); cartPanel = null; } return; }
    if (!wrap || (cartPanel && document.body.contains(cartPanel))) return;
    cartPanel = buildPanel(initialValues(), function (v) {
      if (v.occasion && v.heard) saveAttributes(v.occasion, v.heard);
    });
    cartPanel.querySelector('.sc-ev-sub').textContent = 'Required before checkout.';
    wrap.parentNode.insertBefore(cartPanel, wrap);
    // Carry over earlier answers (e.g. from the configurator or product page) if the cart lost them
    var v0 = cartPanel.__values();
    if (v0.occasion && v0.heard && missing()) saveAttributes(v0.occasion, v0.heard);
    if (/sc-event-info/.test(location.hash) && missing()) setTimeout(function () { cartPanel.__showError(); }, 300);
  }
  var proceeding = false;
  window.addEventListener('click', function (e) {
    if (proceeding) return;
    var t = e.target && e.target.closest ? e.target.closest('[name="checkout"], .cart__checkout, a[href="/checkout"], a[href^="/checkout?"]') : null;
    if (!t || !cartState.catering) return;
    var onPagePanel = onCartPage && cartPanel && document.body.contains(cartPanel);
    if (onPagePanel) {
      var v = cartPanel.__values();
      if (!(v.occasion && v.heard)) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        cartPanel.__showError();
        track('catering_event_info_missing', { page: 'cart' });
        return;
      }
      if (v.occasion !== cartState.occasion || v.heard !== cartState.heard || saving) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        (saving || Promise.resolve()).then(function () { return saveAttributes(v.occasion, v.heard); }).then(function () {
          proceeding = true; t.click(); setTimeout(function () { proceeding = false; }, 1500);
        });
      }
      return;
    }
    if (missing()) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      track('catering_event_info_missing', { page: 'drawer' });
      location.href = '/cart#sc-event-info';
    }
  }, true);
  // Hide express-checkout buttons while answers are missing on a catering cart
  function syncExpress() {
    var hide = missing();
    var els = document.querySelectorAll('.additional-checkout-buttons, .shopify-payment-button');
    for (var i = 0; i < els.length; i++) {
      if (els[i].closest('form[action*="/cart/add"]')) continue;
      els[i].style.display = hide ? 'none' : '';
    }
  }
  setInterval(syncExpress, 1000);
  // Track cart mutations so the drawer gate stays accurate
  var prevFetch2 = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = prevFetch2.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/i.test(url)) res.then(function () { setTimeout(refreshCart, 150); }, function () {});
    return res;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncCartPanel(); refreshCart(); });
  else { syncCartPanel(); refreshCart(); }
})();
